import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <p>We stand with everyone fighting on the frontlines</p>
        <p className="designed">
          Designed by{" "}
          <a href="https://anandshukla.com" target="_blank" rel="noreferrer">
            Anand Shukla
          </a>
        </p>
      </div>
    </div>
  );
}

export default Footer;
